import { Badge, BadgeProps, IconArrowDown, Text } from '@cmpsr/components';

type ActionPlanBadgeProps = {
  text: string;
  isNonQuantifiable?: boolean;
} & BadgeProps;

export default function ActionPlanBadge({ text, isNonQuantifiable, ...props }: ActionPlanBadgeProps) {
  return (
    <Badge
      color="text-success"
      justifyContent={'center'}
      minWidth={isNonQuantifiable ? 8 : 'auto'}
      w="max-content"
      minHeight={6}
      backgroundColor="alert-success-default"
      py="2px"
      px="4px"
      leadingIcon={<IconArrowDown size="xs" />}
      {...props}
    >
      {isNonQuantifiable ? null : (
        <Text color="text-success" variant="text-body-floating-label-bold">
          {text}
        </Text>
      )}
    </Badge>
  );
}
